import gql from 'graphql-tag';

const featureFlagQuery = gql`
  query featureFlagQuery($size: Int, $offset: Int) {
    featureFlags(offset: $offset, size: $size) {
      id
      description
      flagName
      checked
    }
  }
`;

export default featureFlagQuery;
